import type React from 'react';

import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { FullscreenEnterIcon } from '../../icons/fullscreen-enter';
import { FullscreenExitIcon } from '../../icons/fullscreen-exit';
import { Tooltip } from '../tooltip/tooltip';

import styles from './fullscreen-button.module.css';

type Props = {
  isFullscreen?: boolean;
  className?: string;
  onClick?: () => void;
};

export function FullscreenButton({ isFullscreen = false, onClick, className }: Props) {
  const { t } = useTranslation();

  return isFullscreen ? (
    <FullscreenExitButton className={className} label={t('ui.fullscreen.button.label.active')} onClick={onClick} />
  ) : (
    <FullscreenEnterButton className={className} label={t(`ui.fullscreen.button.label.inactive`)} onClick={onClick} />
  );
}

type ButtonProps = {
  label: string;
  className?: string;
  onClick?: () => void;
};

function FullscreenEnterButton({ label, onClick, className }: ButtonProps) {
  const trigger = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        type="button"
        name="fullscreen-button"
        className={classNames(className, styles.button)}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <FullscreenEnterIcon />
      </button>
    ),
    [className, onClick]
  );
  return <Tooltip tooltip={label} trigger={trigger} />;
}

function FullscreenExitButton({ label, onClick, className }: ButtonProps) {
  const trigger = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        type="button"
        name="fullscreen-exit-button"
        className={classNames(className, styles.button)}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <FullscreenExitIcon />
      </button>
    ),
    [className, onClick]
  );
  return <Tooltip tooltip={label} trigger={trigger} />;
}
